var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxlPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4502 12.5845L17.6536 9.38108L7.30667 3.56575C6.62092 3.19525 5.9785 3.14325 5.41517 3.54841L14.4502 12.5845ZM18.1996 16.335L21.5297 14.4619C22.1797 14.0979 22.5362 13.5822 22.5362 13.0102C22.5362 12.4393 22.1797 11.9226 21.5308 11.5586L18.5159 9.86533L15.1218 13.2583L18.1996 16.335ZM4.85833 4.336C4.789 4.54941 4.75 4.78775 4.75 5.04883V20.9792C4.75 21.392 4.841 21.7473 5.00567 22.0301L13.7774 13.2572L4.85833 4.336ZM14.4502 13.9289L5.72717 22.653C5.894 22.7169 6.07383 22.7505 6.26342 22.7505C6.60142 22.7505 6.9535 22.6508 7.31208 22.4515L17.3383 16.8214L14.4502 13.9289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlPlayStore);
export default __webpack_public_path__ + "static/media/bxl_play-store.ec44b98a8bb210525d0a3297060186a9.svg";
export { ForwardRef as ReactComponent };